const TAB_NUMBER = 'TAB_NUMBER';
const RECENT_CASES = 'RECENT_CASES';
const CASE_STAGE_ID = 'CASE_STAGE_ID';
const LOCKED_CASES = 'lockedCases';
const OPEN_RECENT_CASES = 'recentCases';
const LOGOUT = 'otherTabLogout';
const OP1_DETAILS = 'op1CaseDetail';
const LOCKED_IMAGES = 'lockedImages';

export function setLocalStorageValue(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getLocalStorageValue(key) {
  let item = localStorage.getItem(key);
  if (item) {
    return JSON.parse(item);
  }
  return null;
}

export function clearLocalStorageItems() {
  localStorage.removeItem(CASE_STAGE_ID);
}

export function setLockedCaseCount(value) {
  return value >= 0 && setLocalStorageValue(TAB_NUMBER, value);
}

export function getLockedCaseCount() {
  return getLocalStorageValue(TAB_NUMBER);
}

export function setRecentCasesCount(value) {
  return setLocalStorageValue(RECENT_CASES, value);
}

export function removeRecentCasesCount() {
  return localStorage.removeItem(OPEN_RECENT_CASES);
}

export function getRecentCasesCount() {
  return getLocalStorageValue(RECENT_CASES);
}

export function setCaseStageId(value) {
  return setLocalStorageValue(CASE_STAGE_ID, value);
}

export function getCaseStageId() {
  return getLocalStorageValue(CASE_STAGE_ID);
}

export function getLockedCases() {
  if (getLocalStorageValue(LOCKED_CASES)) {
    return getLocalStorageValue(LOCKED_CASES);
  }
  return [];
}

export function setLockedCases(caseNumber, caseStageId) {
  let currentLockedCases = getLockedCases();
  const updateLockedCases = currentLockedCases.concat({
    caseNumber: parseInt(caseNumber),
    caseStageId: caseStageId,
    date: Date.now(),
  });
  return setLocalStorageValue(LOCKED_CASES, updateLockedCases);
}

export function removeLockedCases(caseNumber, caseStageId) {
  const currentLockedCases = getLockedCases();
  let caseToBeRemoved = currentLockedCases.find(
    (caseObject) => caseObject.caseNumber === caseNumber && caseObject.caseStageId === caseStageId,
  );
  if (caseToBeRemoved) {
    let changedLockedCases = currentLockedCases.filter((caseObject) => caseObject.date !== caseToBeRemoved.date);
    return setLocalStorageValue(LOCKED_CASES, changedLockedCases);
  }
  return setLocalStorageValue(LOCKED_CASES, currentLockedCases);
}

export function checkCaseIsPresent(caseNumber, caseStageId) {
  removeLockedCases(caseNumber, caseStageId);
  const currentLockedCases = getLockedCases();
  const currentCase = currentLockedCases.find(
    (caseObject) => caseObject.caseNumber === caseNumber && caseObject.caseStageId === caseStageId,
  );
  if (currentCase) {
    return true;
  }
  return false;
}

export function clearLockedCaseArray() {
  localStorage.removeItem(LOCKED_CASES);
}

export function clearTabNumber() {
  localStorage.removeItem(TAB_NUMBER);
}

export function clearLogoutSettings() {
  localStorage.removeItem(LOGOUT);
}

export function setOtherTabLogout(value) {
  return setLocalStorageValue(LOGOUT, value);
}

export function getOtherTabLogout() {
  return getLocalStorageValue(LOGOUT);
}

export function clearOp1CaseDetail() {
  localStorage.removeItem(OP1_DETAILS);
}

export function setOp1CaseDetail(value) {
  return setLocalStorageValue(OP1_DETAILS, value);
}

export function getOp1CaseDetail() {
  return getLocalStorageValue(OP1_DETAILS);
}

export function getLockedImageCount() {
  return getLocalStorageValue(TAB_NUMBER);
}

export function setLockedImageCount(value) {
  return value >= 0 && setLocalStorageValue(TAB_NUMBER, value);
}

export function getLockedImages() {
  if (getLocalStorageValue(LOCKED_IMAGES)) {
    return getLocalStorageValue(LOCKED_IMAGES);
  }
  return [];
}

export function setLockedImages(documentId) {
  let currentLockedImages = getLockedImages();
  const updateLockedImages = currentLockedImages.concat({
    documentId: parseInt(documentId),
    date: Date.now(),
  });
  return setLocalStorageValue(LOCKED_IMAGES, updateLockedImages);
}

export function removeLockedImages(documentId) {
  const currentLockedImages = getLockedImages();
  let imageToBeRemoved = currentLockedImages.find((imageObject) => imageObject.documentId === documentId);
  if (imageToBeRemoved) {
    let changedLockedImages = currentLockedImages.filter((imageObject) => imageObject.date !== imageToBeRemoved.date);
    return setLocalStorageValue(LOCKED_IMAGES, changedLockedImages);
  }
  return setLocalStorageValue(LOCKED_IMAGES, currentLockedImages);
}

export function checkImageIsPresent(documentId) {
  removeLockedImages(documentId);
  const currentLockedImages = getLockedImages();
  const currentImage = currentLockedImages.find((imageObject) => imageObject.documentId === documentId);
  if (currentImage) {
    return true;
  }
  return false;
}

export function clearLockedImageArray() {
  localStorage.removeItem(LOCKED_IMAGES);
}
